/**
 * Default REST API origin when `REACT_APP_API_BASE_URL` is unset (vizhacks_api, port 3010).
 * Axios uses this + {@link API_VERSION_PREFIX} — no CRA proxy; ensure API `CORS_ORIGINS` includes the SPA (e.g. http://localhost:3000).
 */
export const DEFAULT_LOCAL_API_ORIGIN = "http://192.168.100.212:3010";

/**
 * Backend origin (no trailing slash). Always a full URL unless overridden by env.
 * Override: `REACT_APP_API_BASE_URL=https://api.example.com`
 */
function resolveApiBaseUrl() {
  const raw = process.env.REACT_APP_API_BASE_URL;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw).replace(/\/$/, "");
  }
  return DEFAULT_LOCAL_API_ORIGIN;
}

export const API_BASE_URL = resolveApiBaseUrl();

/**
 * Socket.IO origin (no path). **Not** the REST API host — the vizhacks_socket service
 * (default local `http://localhost:3030`). Override with `REACT_APP_SOCKET_URL`.
 */
function resolveSocketOrigin() {
  const raw = process.env.REACT_APP_SOCKET_URL;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw).replace(/\/$/, "");
  }
  return "http://192.168.100.212:3030";
}

export const SOCKET_ORIGIN = resolveSocketOrigin();

/** API version prefix appended to base (REST resources live under this). */
export const API_VERSION_PREFIX = "/v1";

/** Axios baseURL: `{API_BASE_URL}{API_VERSION_PREFIX}` e.g. `http://localhost:3010/v1`. */
export function getHttpClientBaseUrl() {
  const root = API_BASE_URL.replace(/\/$/, "");
  return `${root}${API_VERSION_PREFIX}`;
}

/**
 * Socket.io `io()` URL — dedicated socket service (see integration guide §2, §9.1).
 * In dev, defaults to `http://localhost:3030` (REST uses {@link DEFAULT_LOCAL_API_ORIGIN} separately).
 */
export function getSocketIoUrl() {
  return SOCKET_ORIGIN.replace(/\/$/, "");
}

/** Engine.IO path (must match vizhacks_socket; default is `/socket.io`). */
export const SOCKET_PATH = "/socket.io";
